import React from 'react';
import { ButtonProps } from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Button from '../Button/Button';

const useStyles = makeStyles(() => ({
  text: {
    lineHeight: 1
  },
  icon: {
    width: '30px',
    height: '30px',
    transition: '0.3s'
  },
  iconRotate: {
    transform: 'rotate(180deg)',
    width: '30px',
    height: '30px',
    transition: '0.3s'
  },
  empty: {
    padding: 0,
    minWidth: '42px',
    '& .MuiButton-endIcon': {
      marginLeft: 0,
      marginRight: 0
    }
  }
}));

interface ButtonPropsExtended extends ButtonProps {
  children?: any;
  isOpen?: boolean;
}

const ButtonExpand = ({ children, isOpen, ...rest }: ButtonPropsExtended) => {
  const classes = useStyles(rest);

  return (
    <Button
      {...rest}
      endIcon={
        <ExpandMoreIcon
          className={isOpen ? classes.iconRotate : classes.icon}
        />
      }
    >
      {children}
    </Button>
  );
};

export default ButtonExpand;
